import { render, staticRenderFns } from "./RatingSystem.vue?vue&type=template&id=1d58074c&scoped=true&"
import script from "./RatingSystem.vue?vue&type=script&lang=js&"
export * from "./RatingSystem.vue?vue&type=script&lang=js&"
import style0 from "./RatingSystem.vue?vue&type=style&index=0&id=1d58074c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d58074c",
  null
  
)

export default component.exports